export default "__VITE_ASSET__DYNm6eLi__"